/**
 * Check whether a value should be treated as present for query params.
 * @param {*} value - Value to evaluate.
 * @returns {boolean} True when value is not null, undefined, or empty string.
 */
const hasValue = value => value !== null && value !== undefined && value !== '';

/**
 * Validate that a required value is present.
 * @param {*} value - Value to validate.
 * @param {string} name - Parameter name used in the error message.
 * @throws {Error} Throws when value is missing.
 */
const requireValue = (value, name) => {
  if (!hasValue(value)) {
    throw new Error(`${name} is required`);
  }
};

/**
 * Append a query param only when its value is present.
 * @param {URLSearchParams} params - Query params instance to mutate.
 * @param {string} key - Query param name.
 * @param {*} value - Query param value.
 * @param {Function} [transform] - Optional value transform before append.
 * @returns {void}
 */
const appendParamIfPresent = (params, key, value, transform = v => v) => {
  if (hasValue(value)) {
    params.append(key, transform(value));
  }
};

const queryParams = {
  hasValue,
  requireValue,
  appendParamIfPresent
};

export default queryParams;